/**
 * How far along a plan is (Đầu tư screen, decision Y1).
 *
 * The honest part of this function is what it REFUSES to answer. A plan holds two kinds of
 * target and only one of them can be checked today:
 *
 * - **Money targets** ("giải ngân 24 triệu trong năm") — the ledger knows exactly how much
 *   went into an investment destination, so progress is real.
 * - **Weight targets and bands** ("FUEVN100 17–20%") — nobody can say what the actual weight
 *   is until holdings exist in the database (Domain v1.3, Phase 3). A screen that showed a
 *   made-up percentage here would be worse than one that shows nothing.
 *
 * So every item comes back with `comparable` and, when false, the reason — and the screen
 * prints the reason instead of a bar.
 *
 * Pure. Both numbers arrive already summed by SQL (DBD-014); the only arithmetic is one
 * division for the percentage.
 */
/** Targets whose actual value the ledger can answer today. */
const MONEY_TARGETS = new Set(['capital_invested']);
/** Targets that need to know what is actually held — Phase 3. */
const WEIGHT_TARGETS = new Set([
    'asset_weight',
    'sector_weight',
    'maximum_single_stock_weight',
    'fundamental_metric',
]);
export function computePlanProgress(input) {
    return input.targets.map((target) => {
        const base = {
            targetType: target.targetType,
            symbol: target.symbol,
            targetValue: target.targetValue,
            targetUnit: target.targetUnit,
            operator: target.operator,
        };
        if (MONEY_TARGETS.has(target.targetType)) {
            const actual = input.investedYtd;
            // A target of zero has no meaningful percentage; reporting 0% would read as "behind".
            const pct = target.targetValue > 0 ? (actual / target.targetValue) * 100 : null;
            return { ...base, actual, pct, comparable: true, reason: null };
        }
        return {
            ...base,
            actual: null,
            pct: null,
            comparable: false,
            reason: WEIGHT_TARGETS.has(target.targetType) ? 'needs_holdings' : 'not_tracked',
        };
    });
}
//# sourceMappingURL=planProgress.js.map